// Список совместных чтений: модалка создания чтения.
import { application } from "../application.js";

import CoreadingNewController from "../controllers/coreading_new_controller.js";

application.register("coreading-new", CoreadingNewController);

export { application };
